import { AnalyticsDashboardResponse } from "../models/Analytics";
import apiClient from "./api-client";

const ANALYTICS_BASE_URL = "/analytics/dashboard";

export const getAnalyticsDashboard = async (): Promise<AnalyticsDashboardResponse> => {
	const response = await apiClient.get<AnalyticsDashboardResponse>(ANALYTICS_BASE_URL);
	return response.data;
};
